import LyraSentryClient from '@lyra-network/lyra-common-sentry-client/dist/lyra-sentry-client.minimal.esm'
import 'globalthis/auto'

export function detectEnvironment(customHostname) {
    const hostname = customHostname || window.location.hostname
    const IPV4_PATTERN =
        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/

    // Case local dev
    if (
        !hostname ||
        '__PASS_SENTRY_ENV__' === 'dev' || // '__PASS_SENTRY_ENV__' replaced during KJS build
        hostname.includes('localhost') ||
        hostname.includes('-dev-l') ||
        hostname.endsWith('.local') ||
        IPV4_PATTERN.test(hostname)
    ) {
        return 'dev'
    }

    // Case inte01, inte02, inte03, etc.
    const inteMatch = hostname.match(/[.-](inte\d+)[.-]/i)
    if (inteMatch) {
        return inteMatch[1].toUpperCase() // -> INTE01, INTE02, ...
    }
    // Default, production
    return 'TRV_PROD'
}
const environment = detectEnvironment()

const Sentry = LyraSentryClient.init({
    dsn: '__DSN__',
    environment,
    release: `__APP_NAME__@__VERSION__`,
    denyUrls: [/localhost/, /-dev-l-/],
})

/**
 * Safe add extra information for current scope
 * @param data
 */
export function fillTagsAndExtras(data) {
    if (!data) return

    const { applicationProvider, applicationVersion, mode, serverUrl, answer } = data
    const extras = { mode, serverUrl }

    Sentry.setTag('applicationProvider', applicationProvider)
    Sentry.setTag('applicationVersion', applicationVersion)

    if (answer) {
        extras.sessionId = answer.operationSessionId

        const { result } = answer
        if (result) {
            Sentry.setTag('authenticateId', result.id)
            Object.assign(extras, {
                authenticateId: result.id,
                protocol: result.protocol,
                acsUrl: result.value?.http?.url,
            })
        }
    }

    Sentry.setExtras(extras)
}

export default Sentry
